
import ps5 from './ps5.mp4';


export default function Square() {
  
  return <div className='main'>
          <video src={ps5} autoPlay loop muted/>
          <div className='overlay'></div>
          <div className='intro'>
            <div className='titles'>
              <h1 className='title-1'>Bagaax</h1>
              <h1>Games</h1>
            </div>
            <p>Play to your heart's content</p>
            <button>Play</button>
          </div>
        </div> 
}
